import { RouterManager } from '@aclass/admin/managers';
import { CampaignStory } from '@aclass/admin/storage/actions';
import { IAdminState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class CampaignCreateStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:campaign-create';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<boolean | null>(['campaignModule', 'createPageInitialized']).pipe(filter(v => v));
        this.employee = this.routerManager.onRejectNavigation(CampaignCreateStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(CampaignStory.dryRunCreatePage());
    }
}
